(function () {
  const formSelector = 'form.saloa-lite-ajax-cart';

  function getCartDrawer() {
    return document.getElementById('CartDrawer');
  }

  function getSectionsToRender() {
    if (window.xCartHelper && typeof window.xCartHelper.getSectionsToRender === 'function') {
      const sectionId = getCartDrawer()?.dataset.sectionId;
      return window.xCartHelper.getSectionsToRender(sectionId);
    }

    return [
      {id: 'cart-icon-bubble', selector: '#cart-icon-bubble'},
    ];
  }

  function renderSection(html, selector) {
    const target = document.querySelector(selector);
    if (!target || !html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector(selector);
    if (replacement) target.innerHTML = replacement.innerHTML;
  }

  function openCartDrawer() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    cartDrawer.isOpen = true;
    cartDrawer.setAttribute('open', '');
    document.getElementById('CartDrawer__Wrapper')?.classList.add('is-visible');
  }

  function getFormItem(form) {
    const formData = new FormData(form);
    const id = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);

    if (!id || quantity < 1) return null;
    return {id, quantity};
  }

  function submitNative(form) {
    form.dataset.saloaLiteNativeSubmit = 'true';
    form.requestSubmit ? form.requestSubmit() : form.submit();
  }

  function setLoading(form, isLoading) {
    const button = form.querySelector('[type="submit"][name="add"]');
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading || button.hasAttribute('data-saloa-was-disabled');
  }

  function addItem(item) {
    const sectionsToRender = getSectionsToRender();
    const sections = sectionsToRender.map((section) => section.id).filter(Boolean);

    return fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [item], sections}),
    }).then((response) => {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then((response) => {
      if (response.sections) {
        sectionsToRender.forEach((section) => {
          renderSection(response.sections[section.id], section.selector);
        });
      }

      if (window.xCartHelper && typeof window.xCartHelper.updateCurrentCountItem === 'function') {
        window.xCartHelper.updateCurrentCountItem();
      }

      if (window.CART_EVENT?.cartUpdate) {
        document.dispatchEvent(new CustomEvent(window.CART_EVENT.cartUpdate, {detail: {openMiniCart: true}}));
      }

      openCartDrawer();
      document.dispatchEvent(new CustomEvent('saloa:lite-cart:add', {detail: {item}}));
    });
  }

  window.SaloaLiteCart = Object.assign({}, window.SaloaLiteCart, {
    addItem,
    openCartDrawer,
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest(formSelector);
    if (!form || form.dataset.saloaLiteNativeSubmit === 'true') return;

    const item = getFormItem(form);
    if (!item || !window.fetch || !window.Shopify?.routes?.root) return;

    event.preventDefault();
    setLoading(form, true);

    addItem(item)
      .catch(function () {
        submitNative(form);
      })
      .finally(function () {
        setLoading(form, false);
      });
  }, true);
})();
